import { getOrderTicketsForShowtime } from './get-order-tickets-for-showtime';
export const getOrderTicketQuantityForShowtime = (showtimeId, ticket) => {
    return getOrderTicketsForShowtime(showtimeId, ticket).length;
};
